export const CIPcolors = {
    "Bond 2016": "#0247ae",
    "Operating Budget": "#E67125",
    "Capital Improvement Plan": "#e65300",
    "Bond 2024": "#1597d5",
    "Helene Recovery": "#C78800",
  };